import React from 'react';
import mobile from "../../images/Mobil.png";
import appsQr from "../../images/apps_qr.png";
import strings from '../../utils/locals/languages';

const GetTheApp = () => {
    const openApp = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/android/i.test(userAgent)) {
            window.open(
                "https://play.google.com/store/apps/details?id=com.esols.egasi&pcampaignid=web",
                "_blank",
                "noopener,noreferrer"
            );
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.open(
                "https://apps.apple.com/us/app/egasi-net/id6639613472?platform=iphone",
                "_blank",
                "noopener,noreferrer"
            );
        } else {
            window.open(
                "https://www.egasi.net/",
                "_blank",
                "noopener,noreferrer"
            );
        }
    };

    return (
        <div className="container mb-4">
            <div className="bg-white shadow-md rounded-lg p-1">
                <div className="flex flex-col md:flex-row items-center justify-around gap-5">
                    {/* Left side: Text + Phone */}
                    <div className="flex items-center gap-5">
                        <div className="max-w-xs">
                            <h6 className="text-2xl font-semibold text-orange-400">{strings.getApp}</h6>
                            <p className="text-sm mt-2">{strings.getAppP}</p>
                        </div>
                        <img className="w-40 md:w-52 h-auto" src={mobile} alt="Mobile Preview" />
                    </div>

                    {/* Right side: QR Code */}
                    <div>
                        <img
                            className="w-40 md:w-52 h-auto cursor-pointer"
                            src={appsQr}
                            alt="QR Code"
                            onClick={openApp}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GetTheApp;
